import src from "IMAGE";
export default { src, width: 1009, height: 168, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/ALKysm2sra1rpqamXKurq2Czs7NtsLGxbq+vsGy6urpkRhITtrfkimYAAAAASUVORK5CYII="};
